module.exports = __webpack_public_path__ + "static/media/download-catalog.b58e70d5.gif";